<template>
  <div id="app" :class="{ 'dark-mode': !$store.state.theme.isLightMode, 'light-mode': $store.state.theme.isLightMode }">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {}
  },
  created() {
    if (localStorage.getItem('isLightMode')) {
        this.$store.commit('theme/changeTheme', JSON.parse(localStorage.getItem('isLightMode')));
    }
  },
  mounted() {

  }
}
</script>
<style>
body {
  margin: 0;
  padding: 0;
}

#app {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
